module.exports = __webpack_public_path__ + "img/2025-09_academic-excellence.159ab2fc.webp";